import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

const useBulkUploadFilters = () => {
  const [selectedFilter, setSelectedFilter] = useState('filename');
  const [dateRange, setDateRange] = useState({ created_on: { type: 'date', start: null, end: null } });
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    let query = buildQuery();
    setCurrentQuery(query);
  }, [selectedFilter, selectedStatus, selectedCategory, dateRange, pagination]);

  const buildQuery = () => {
    const query = { ...pagination };
    if (searchTerm) {
      query[selectedFilter] = searchTerm;
    }
    if (!isEmpty(query)) {
      query.status = selectedStatus;
      query.category = selectedCategory.split(" ")[0];
      query.subCategory = selectedCategory.split(" ")[1];
    }
    if (dateRange?.document_date?.start || dateRange?.document_date?.end) {
      const { start, end } = dateRange.document_date;
      const cleanDateObject = { ...(start && { start }), ...(end && { end }) };
      if (Object.keys(cleanDateObject).length) {
        query.created_on = JSON.stringify(cleanDateObject);
      }
    }
    return query;
  };
  const [currentQuery, setCurrentQuery] = useState(buildQuery());

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleDateRangeChange = (newDateRange) => setDateRange(newDateRange);

  const handlePaginationChange = (page, limit) => setPagination({ page: page, size: limit });

  const handleStatusChange = (event) => setSelectedStatus(event.target.value);

  const handleCategoryChange = (event) => setSelectedCategory(event.target.value);

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
    }
  };

  return {
    searchTerm,
    selectedStatus,
    selectedCategory,
    selectedFilter,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleDateRangeChange,
    handlePaginationChange,
    handleStatusChange,
    handleCategoryChange,
  };
};

export default useBulkUploadFilters;
